import $ from "jquery";
import "slick-carousel";

const hotspotSlider = document.querySelector('.hotspot-slider');

$(".slider").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "150px",
  dots: true,
  responsive: [
    {
      breakpoint: 800,
      settings: {
        centerMode: false,
        centerPadding: "0px",
      },
    },
  ],
});

if (hotspotSlider) {
  hotspotSlider.dataset.currentSlide = '0';

  $('.slider--hotspot').on('afterChange', function(event, slick, currentSlide){
    hotspotSlider.dataset.currentSlide = currentSlide;
  });
}

